import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className='container img-bck bck-media'>
        <div className='col-12 text-center margin'>
          <h3 className='text-dark'>
            Sé quien tú quieras ser, descubre junto a la <br />
            Universidad Mayor las profesiones que más se
            <br />
            ajustan a tu personalidad.
          </h3>
          <Link
            to='/login'
            className='btn btn-lg btn-black'
            style={{ marginTop: '10px', fontSize: '1.2rem' }}>
            Empezar
          </Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.jsx